<template>
  <div class="office">
    <div class="header">
      <section class="hero is-medium">
        <div class="hero-body">
          <div class="">
            <h3 class="title">Organigramme</h3>
          </div>
        </div>
      </section>
    </div>
    <div class="component">
      <OrganigrammeDiagram />
    </div>
  </div>
</template>

<script>
import OrganigrammeDiagram from "@/components/communs/OrganigrammeDiagram.vue";

export default {
  name: "OfficeView",
  components: { OrganigrammeDiagram },
};
</script>

<style lang="scss">
.office {
  .hero {
    text-align: center;
    margin-top: 0;
    background: #1a1a1a;

    h3 {
      margin-left: 0;
    }

    &::before {
      content: none;
    }

    .title {
      color: #ffffff;
      margin-left: 0;
    }
  }
}
</style>
